<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

export interface IDSKSkipLinkProps {
  contentId: string
  dataTestId?: string
}

const { t } = useI18n()

const props = withDefaults(defineProps<IDSKSkipLinkProps>(), {
  dataTestId: '',
})
</script>

<template>
  <a
    :href="`#${props.contentId}`"
    class="govuk-skip-link"
    :data-test-id="
      props.dataTestId ? 'skip.link.' + props.dataTestId : 'skip.link.' + props.contentId
    "
    >{{ t('text') }}</a
  >
</template>

<style scoped></style>

<i18n lang="yaml">
sk:
  text: 'Preskočiť na hlavný obsah'
en:
  text: 'Skip to main content'
</i18n>
